'use strict';

const _ = require('lodash');

const mediator = require('./../../core/mediator');

const Notifier = require('./../notifier');

module.exports.add = function(message, type) {
    let flash = localStorage.getItem('flash') ? JSON.parse(localStorage.getItem('flash')) : [];
    let typeNotification = ['success', 'info', 'error', 'warning'];

    flash.push({'message': message, 'type': _.indexOf(typeNotification, type) === -1 ? 'info' : type});
    localStorage.setItem('flash', JSON.stringify(flash));
};

module.exports.flash = function() {
    _.forEach(JSON.parse(localStorage.getItem('flash')), function(value) {
        Notifier[value.type](value.message);
    });

    localStorage.removeItem('flash');
};

module.exports.addCallback = function(type, force = false) {
    let flash = localStorage.getItem('flash-callback') ? JSON.parse(localStorage.getItem('flash-callback')) : [];

    flash.push({'type': type, force});

    localStorage.setItem('flash-callback', JSON.stringify(flash));
};

module.exports.flashCallback = function() {
    _.forEach(JSON.parse(localStorage.getItem('flash-callback')), function(value) {
        setTimeout(function() {
            let name = value && value.type ? value.type: 'default';

            mediator.publish(value.force ? value.type : `flash-callback:${name}`);
        }, 0);
    });

    localStorage.removeItem('flash-callback');
};
